/**
 * Global
 */

class Global {

  static confirm( msg, resolve, reject ) {
    const r = confirm( msg );
    if ( r ) {
    resolve();
    } else {
    reject();
    }
  }
}

export default Global;
